<pfx-dialog>
  <pfx-dashboard-layout>
    <ng-template pfxTemplate>
      <pfx-panel
        [title]="'details' | i18next: { ns: i18nNamespace }"
        [toggleable]="true"
      >
        <pfx-order-update
          class="w-full"
          [orderId]="orderId()"
        ></pfx-order-update>
      </pfx-panel>
    </ng-template>
    <ng-template pfxTemplate>
      <pfx-panel
        [title]="'appointments' | i18next: { ns: i18nNamespace }"
        [toggleable]="true"
      >
        {{ 'appointments' | i18next: { ns: i18nNamespace } }}
      </pfx-panel>
    </ng-template>
  </pfx-dashboard-layout>
</pfx-dialog>
